export const convertName = (req) => {
    switch (req) {
        case 'username':
            return 'Kullanıcı Adı';
        case 'password':
            return 'Şifre';
        case 'domainCode':
            return 'Ürün Kodu';
        default:
            return req;
    }
};

export const convertReq = (req) => {
    let copy = {};
    req.forEach((req) => {
        copy[req] = '';
    });

    return copy;
};

// Mikrokom response'unu Luca formatına çevirme fonksiyonları
export const convertMikrokomResponseToLucaFormat = (mikrokomData) => {
    return mikrokomData.map((company) => ({
        company: {
            label: company.companyName,
            value: company.companyId
        },
        periods: company.periods.map((period) => ({
            label: period.period_name,
            value: period.id
        }))
    }));
};

export const getPeriodForDropdown = (periodList, companyValue) => {
    let period = [];
    periodList.forEach((item) => {
        if (item.company.value === companyValue) {
            item.periods.forEach((p) => {
                period.push({
                    title: p.label,
                    value: p.value
                });
            });
        }
    });
    return period;
};

export const getCompanyForDropdown = (data) => {
    let company = [];
    data.forEach((item) => {
        company.push({
            title: item.company.label,
            value: item.company.value
        });
    });
    return company;
};

export const deleteCompanyIsHere = (data, company) => {
    let copy = [];
    data.forEach((item) => {
        if (company.find((c) => c.companyCode === item.value) === undefined) {
            copy.push(item);
        }
    });
    return copy;
};

export const sortReq = (req, sortArray) => {
    let sortedKeys = Object.keys(req).sort(function (a, b) {
        return sortArray.indexOf(a) - sortArray.indexOf(b);
    });

    return sortedKeys;
};

// Mikrokom'a özel utility fonksiyonları
export const getMikrokomCompanyForDropdown = (mikrokomData) => {
    return mikrokomData.map((company) => ({
        title: company.companyName,
        value: company.companyId
    }));
};

export const getMikrokomPeriodForDropdown = (mikrokomData, companyId) => {
    const company = mikrokomData.find((comp) => comp.companyId === companyId);
    if (!company) return [];

    return company.periods.map((period) => ({
        title: period.period_name,
        value: period.id
    }));
};

// Mikrokom company bilgilerini almak için
export const getMikrokomCompanyInfo = (mikrokomData, companyId) => {
    return mikrokomData.find((comp) => comp.companyId === companyId);
};

// Vergi numarası veya TC kimlik için
export const getCompanyTaxInfo = (company) => {
    return company.companyVkn || company.companyTck || '';
};
